import React, { useState } from 'react';
import { Select, Button, DatePicker, Modal, Alert, message, Spin } from 'antd';

import Grid from '@material-ui/core/Grid';
import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
import TechnicalRepresentativeContainer from 'app/containers/TechnicalRepresentativeContainer';
import CommunicationProgramContainer from 'app/containers/CommunicationProgramContainer';
import FrontContainer from 'app/containers/FrontContainer';
import SupervisorContainer from 'app/containers/SupervisorContainer';
import ApiService from 'app/services/ApiService';
import { auth } from 'app/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBookmarkPreview, fetchBookmarkCourseFilters } from 'app/actions/BookmarkActions';
import { getBookmarkPreview, getIsLoadingBookmarkPreview, getBookmarkCourseFilters } from 'app/reducers';
import moment from 'moment'
import { debounce } from 'debounce';


const { Option } = Select;
const { confirm } = Modal;

const SelectItem = (name = [], value) => {
    if (name == null) name = [];
    let x = [...new Set(name.map(i => i[value]))];
    x = name.map(i => i[value]);
    return (
        x.map((c, i) => <Option key={i}>{c}</Option>)
    );
}
export default function BookmarksGenerateForm(props) {

    const SelectItem_ = (name = [], value, key) => {
        if (name == null) name = [];
        return (
            name.map((item) =>
                <Select.Option key={`${item[key]}`} value={`${item[key]}`}>{item[value]}</Select.Option>
            )
        );
    }

    const classes = props.classes;
    const styles = props.styles
    let user = useSelector(auth);
    const dispatch = useDispatch();
    const preview = useSelector(getBookmarkPreview)
    const loadingPreview = useSelector(getIsLoadingBookmarkPreview)

    const subdir = '3';
    let [supervisor, setSupervisor] = useState('');
    let [technicalR, setTechnical] = useState();
    const [front, setFront] = useState([]);

    const [name, setName] = useState([]);
    const [creationDateI, setCreationDateI] = useState('');
    const [creationDateF, setCreationDateF] = useState('');
    const [cp, setCP] = useState('');
    const [cp_, setCP_] = useState([]);
    const [visible, isVisible] = useState(false)
    const [messagePDF, setMesag] = useState('Una vez generado el PDF, podrá visualizarlo')
    const [loadingButton, setLoadingButton] = useState(false);
    const [courses, setCourses] = useState([]);

    let bookmarksCourseFilters = useSelector(getBookmarkCourseFilters);

    const submit = () => {
        setLoadingButton(true);
        const bookmarkData = {
            bookmarkName: name,
            endDateCreation: moment(creationDateF).format('YYYY-MM-DD'),
            startDateCreation: moment(creationDateI).format('YYYY-MM-DD'),
            listEmployeeId: [(user.User.IdCompany == null ? user.User.UserId : user.User.IdCompany)],
            listFront: front,
            //listCommunicationProgram: [cp],
            listCommunicationProgram: cp_,
            listSubdirection: [subdir],
            listSupervisor: [supervisor],
            listTechnicalRepresentative: [technicalR],
            listCourse: courses
        }
        ApiService.setBookmarks(bookmarkData).then(
            () => {
                message.success(`El bookmark ${name} se guardó correctamente!`);
                isVisible(false);
                setLoadingButton(false);
                props.onBack();
            },
            () => {
                setLoadingButton(false);
                message.error('Ocurrió un error intente mas tarde.');
            }
        );
    }

    const findCP = (params, v) => {
        let id = params.communicationProgramAvailable[parseInt(v)].idCommunicationProgram;
        setCP(String(id));
    }

    const findCourses = (payload) => {
        setCourses(payload);
    }

    const findCP_ = (payload) => {
        setCP_(payload);
        var model = [];
        payload.forEach(x => {
            model.push(x);
        })
        if (model.length > 0) {
            dispatch(fetchBookmarkCourseFilters({
                IdCommunicationPrograms: model,
            }));
        }

    }


    const findSupervisor = (params, v) => {
        let id = params.supervisor[parseInt(v)].employeeId;
        setSupervisor(String(id));
    }

    const findTechnical = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.technical[values[i]].idResponsible;
            params.technical.forEach((v) => {
                if (v.idResponsible === id) {
                    temp.push(v);
                }
            });
        }
        setTechnical(String(temp[0].idResponsible));
    }

    const findFront = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.front[values[i]].idFront;
            params.front.forEach((v) => {
                if (v.idFront === id) {
                    //temp.push(v);
                    temp.push(v.idFront);
                }
            });
        }
        //setFront(String(temp[0].idFront));
        setFront(temp);
    }

    const disabledStartDate = (current) => {
        if (creationDateF === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) > moment(creationDateF)) {
                return true;
            } else return false;
        }
    }

    const disabledEndDate = (current) => {
        if (creationDateI === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) < moment(creationDateI)) {
                return true;
            } else return false;
        }
    }

    return (
        <div className={classes.root} style={{ flexDirection: 'column', height: '100%' }}>
            <CommunicationProgramContainer>
                {(params) => {
                    return (
                        <div style={{ maxHeight: '70%' }}>
                            <Grid container direction="row">
                                <Grid item xs={6}>

                                    <TextInput
                                        withPadding={true}
                                        value={name}
                                        setValue={setName}
                                        text='Nombre del Bookmark:'
                                        color='darker'
                                        size='label'
                                        mode='input'
                                        weight='medium'
                                        placeholder='Nombre'
                                    />

                                </Grid>

                                <Grid item xs={6}>
                                    <TechnicalRepresentativeContainer>
                                        {(params) => {
                                            return (
                                                <TextInput
                                                    text='Nombre del Revisor del documento (Representante técnico):'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    placeholder='Selecciona revisor'
                                                    style={props.styles.inputSelect}
                                                    showSearch
                                                    onChange={(v) => {
                                                        findTechnical(params, v);
                                                    }}
                                                >
                                                    {SelectItem(params.technical, 'responsibleName')}
                                                </TextInput>
                                            )
                                        }}
                                    </TechnicalRepresentativeContainer>
                                </Grid>
                            </Grid>

                            <Grid container direction="row">
                                <Grid item xs={6}>
                                    {/* <TextInput
                                        text='Programa de comunicación'
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                        placeholder='Selecciona Programa de Comunicación'
                                        style={props.styles.inputSelect}
                                        showSearch
                                        onChange={(v) => {
                                            findCP(props.filter, v);
                                        }}
                                    >
                                        {SelectItem(props.filter.communicationProgramAvailable, 'communicationProgramName')}
                                    </TextInput> */}

                                    <TextEvents
                                        text='Programa de comunicación'
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                    />
                                    <Select
                                        placeholder='Selecciona Programa de Comunicación'
                                        showSearch
                                        onChange={findCP_}
                                        style={props.styles.inputSelect}
                                        optionFilterProp="Children"
                                        allowClear
                                        showArrow={false}
                                        defaultActiveFirstOption={false}
                                        filterOption={false}
                                        mode="multiple"
                                    >
                                        {SelectItem_(props.filter.communicationProgramAvailable, 'communicationProgramName', 'idCommunicationProgram')}
                                    </Select>
                                </Grid>
                                <Grid item xs={6}>
                                    <FrontContainer>
                                        {(front) => {
                                            return (
                                                <TextInput
                                                    text='Frente'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    placeholder='Selecciona frente'
                                                    style={props.styles.inputSelect}
                                                    showSearch
                                                    onChange={(v) => {
                                                        findFront(front, v);
                                                    }}
                                                    mode="multiple"
                                                    
                                                >
                                                    {SelectItem(front.front, 'frontName')}
                                                </TextInput>
                                            )
                                        }}
                                    </FrontContainer>
                                </Grid>
                            </Grid>
                            <Grid container direction="row">
                                <Grid item xs={6}>
                                    <SupervisorContainer>
                                        {(params) => {
                                            return (
                                                <TextInput
                                                    text='Supervisor de AC y CP:'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    placeholder='Selecciona supervisor de ac y cp'
                                                    style={props.styles.inputSelect}
                                                    showSearch
                                                    onChange={(v) => {
                                                        findSupervisor(params, v);
                                                    }}
                                                >
                                                    {SelectItem(params.supervisor, 'employeeName')}
                                                </TextInput>
                                            )
                                        }}
                                    </SupervisorContainer>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextEvents
                                        text='Fecha de Creación:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <TextEvents
                                        text='Desde:'
                                        color="gray"
                                        size='tiny'
                                        weight="light"
                                        styleDisplay='initial'
                                        styleMargin='5px'
                                    />
                                    <DatePicker
                                        style={{ width: '40%' }}
                                        format={'DD/MM/YYYY'}
                                        disabledDate={disabledStartDate}
                                        onChange={(date, dateString) => {
                                            setCreationDateI(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                        }}

                                    /> <TextEvents
                                        text='Hasta:'
                                        color="gray"
                                        size='tiny'
                                        weight="light"
                                        styleDisplay='initial'
                                        styleMargin='5px'
                                    />
                                    <DatePicker
                                        style={{ width: '40%' }}
                                        format={'DD/MM/YYYY'}
                                        disabledDate={disabledEndDate}
                                        onChange={(date, dateString) => {
                                            setCreationDateF(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container direction="row">
                                <Grid item xs={12} md={6}>
                                    <TextEvents
                                        text='Procedimiento:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <Select
                                        placeholder='Seleccione Procedimiento(s)'
                                        showSearch
                                        onChange={findCourses}
                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                        optionFilterProp="Children"
                                        allowClear
                                        showArrow={false}
                                        defaultActiveFirstOption={false}
                                        filterOption={false}
                                        mode="multiple"
                                        disabled={cp_.length <= 0}
                                    >

                                        {SelectItem_(bookmarksCourseFilters, 'course', 'idCourse')}
                                    </Select>
                                </Grid>
                            </Grid>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    disabled={cp_.length === 0 || front === '' || supervisor === '' || creationDateI === '' || creationDateF === ''}
                                    onClick={() => isVisible(true)}
                                >
                                    Guardar
                                </Button>

                            </div>
                            {Object.keys(preview).length > 0 ? <div style={{ height: '100%', display: 'flex', marginBottom: '3%' }}>
                                <embed src={preview.bookmarkUrl} width="100%" height="100%" type="application/pdf" />
                            </div> : <Spin spinning={loadingPreview}>
                                <Alert
                                    message="Información PDF"
                                    description={messagePDF}
                                    type="info"
                                    showIcon
                                />
                            </Spin>
                            }
                        </div>
                    )
                }}
            </CommunicationProgramContainer>
            <Modal
                visible={visible}
                title={<TextEvents
                    text={'Guardar Bookmark'}
                    color='cotemar'
                    size='label'
                    weight='bold'
                />}
                width={'650px'}
                centered={true}
                onCancel={() => isVisible(false)}
                footer={[
                    <Button key="back" type="danger" ghost onClick={() => isVisible(false)}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={loadingButton} onClick={() => submit()}>
                        Confirmar
                    </Button>,
                ]}
            >
                <Grid item xs={12} >
                    <Alert
                        message="Información Adicional"
                        description={'El Bookmark se guardará en la bandeja correspondiente para una futura consulta o exportación del mismo.'}
                        type="info"
                        showIcon
                    />
                </Grid>
            </Modal>
        </div>
    );

}